import { useEffect, useState } from "react";
import { API } from "../../../config";
import { PDFDocument } from "pdf-lib";

export const useCatalogs = () => {
  const [loading, setLoading] = useState(false);
  const [showCreateCategoryDialog, setShowCreateCategoryDialog] =
    useState(false);
  const [showUploadingDialog, setShowUploadingDialog] = useState(false);

  const [catalogs, setCatalogs] = useState(null);

  const handleOpenCreateCategoryDialog = () => {
    setShowCreateCategoryDialog(true);
  };

  const handleCloseCreateCategoryDialog = () => {
    setShowCreateCategoryDialog(false);
  };

  const handleContinueBackground = () => {
    setShowUploadingDialog(false);
    getCatalogs();
  };

  const getCatalogs = async () => {
    setLoading(true);
    const response = await fetch(`${API}/catalogs`, {
      method: "GET",
    }).finally(() => setLoading(false));
    const json = await response.json();
    setCatalogs(json.catalogs);
  };

  useEffect(() => {
    getCatalogs();
  }, []);

  const createCatalogFromPdf = async (data) => {
    const formData = new FormData();

    formData.append("pdf", data.file);

    formData.append("category", data.category);
    formData.append("name", data.name);
    formData.append("brand", data.brand);
    formData.append("show", data.show.toString());
    formData.append("discount", data.discount);

    const response = await fetch(`${API}/catalogs/pdf`, {
      method: "POST",
      body: formData,
    });
    const json = await response.json();
    return json;
  };

  const createCatalogFromLinks = async (data) => {
    const response = await fetch(`${API}/catalogs/url`, {
      method: "POST",
      body: JSON.stringify({
        name: data.name,
        brand: data.brand,
        category: data.category,
        discount: data.discount,
        show: data.show,
        urls: data.urls,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const json = await response.json();
    console.log(json);
    return json;
  };

  const handleSubmitCreateCategoryDialog = async ({
    name,
    brand,
    category,
    discount,
    show,
    file,
    links,
  }) => {
    try {
      setShowUploadingDialog(true);

      if (!!file) {
        const compressedFile = await compressPdf(file);
        const result = await createCatalogFromPdf({
          name,
          brand,
          category,
          discount,
          show,
          file: compressedFile,
        });
      }
      if (links?.length > 0) {
        const result = await createCatalogFromLinks({
          name,
          brand,
          category,
          discount,
          show,
          urls: links,
        });
        console.log("Catalog created from links:", result);
      }
    } catch (error) {
      console.error("Error creating catalog:", error);
    } finally {
      getCatalogs();
      setShowUploadingDialog(false);
    }
  };

  return {
    showCreateCategoryDialog,
    showUploadingDialog,
    handleSubmitCreateCategoryDialog,
    handleOpenCreateCategoryDialog,
    handleCloseCreateCategoryDialog,
    handleContinueBackground,
    catalogs,
    getCatalogs,
    getCatalogsLoading: loading,
  };
};

const compressPdf = async (file) => {
  const arrayBuffer = await file.arrayBuffer();

  const pdfDoc = await PDFDocument.load(arrayBuffer);

  const compressedPdfBytes = await pdfDoc.save({
    useObjectStreams: true,
    addDefaultPage: false,
    objectsPerTick: 50,
  });

  return new Blob([compressedPdfBytes], { type: "application/pdf" });
};
